export default "__VITE_ASSET__3e8c5b5c__"